import { reportMessageToSentry } from "../hooks/useConfigureSentry";
import { CORE_SERVICE_URL } from "@coworker/app/src/hooks/API/core.service";
import { fetchAPI } from "../hooks/API/tasks.service.helper";

export async function updateUser(uid, user) {
  if (!uid || !user) {
    try {
      throw new Error("updateUser: empty id?");
    } catch (error) {
      console.log(error);
    }
    reportMessageToSentry("updateUser empty id!");
    return;
  }
  const userCopy = { ...user, uid };
  if (userCopy.team_id) userCopy["teamId"] = userCopy.team_id;
  if (typeof userCopy.phone !== "undefined")
    userCopy["phoneNumber"] = userCopy.phone;

  const url = `${CORE_SERVICE_URL}/users/${uid}`;
  const { result } = await fetchAPI("PUT", url, userCopy);
  return result;
}
